import axios from 'axios';
import https from 'https';
import store from 'src/store/configureStore';
import { push } from 'redux-first-history';
import { getLoginInfo } from 'src/ui/features/Messaging/state/messagingReselect';
import { loginFailure } from 'src/ui/features/Login/state/loginActions';
import { utlityActionAddRequest, utlityActionUpdateRequest, showNotification } from 'src/utils/utilsActions';

import * as messagingTypes from 'src/ui/features/Messaging/state/messagingTypes';
import { LOGOUT_URL, REQUEST_STATUS } from 'src/constants/constants';
import intl from 'react-intl-universal';
import { clearSession } from '../ui/features/Login/state/loginActions';
import serviceUrls from 'src/constants/serviceUrls';
import DOMPurify from 'dompurify';

const withCredentials = process.env.TARGET_ENV === 'local';
axios.defaults.withCredentials = withCredentials;

axios.interceptors.request.use(
  config =>
    new Promise((resolve, reject) => {
      if (config.method === 'post') {
        axios.get(serviceUrls.X_XSRF_TOKEN_SERVICE).then(({ data }) => {
          config.headers[data.tokenName] = data.token;
          resolve(config);
        }, reject);
      } else {
        resolve(config);
      }
    }),
);

function axiosRequest(method = 'get', url, data, config, errorAction, headerParams, requestId = null) {
  const { isAuthenticated } = getLoginInfo(store.getState());

  // redirect unauthorized user to login page
  if (!isAuthenticated && process.env.NODE_ENV !== 'test') {
    store.dispatch(push(LOGOUT_URL));
    return Promise.reject('Unauthorized');
  }

  const axiosConfig = {
    url,
    method: method.toLowerCase(),
    timeout: 120000,
    withCredentials,
    httpsAgent: new https.Agent({ rejectUnauthorized: true }),
    headers: {
      // 'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'Cache-Control': 'no-cache, no-store, max-age=0',
    },
    data: method === 'post' ? data : null,
    params: method === 'get' ? data : {},
    ...config,
  };

  if (headerParams) {
    axiosConfig.headers = Object.assign(axiosConfig.headers, headerParams);
  }

  //log start loadng with ID
  if (requestId) store.dispatch(utlityActionAddRequest(requestId, REQUEST_STATUS.PENDING));

  return axios(axiosConfig)
    .then(res => {
      const { data } = res;
      //log loading
      if (data.success !== undefined && data.success === false && data.error) {
        const { code: errorCode } = data.error;
        if ((errorCode && parseInt(errorCode, 10) === 401) || parseInt(errorCode, 10) === 403) {
          store.dispatch(loginFailure({ message: intl.get('global.errors.invalidToken') }));
          store.dispatch(push(LOGOUT_URL));
          return { messages: {} };
        }
      }
      if (requestId) {
        setTimeout(() => {
          store.dispatch(utlityActionUpdateRequest(requestId, REQUEST_STATUS.SUCCESS));
        }, 800);
      }
      return data;
    })
    .catch(error => {
      if (requestId) {
        setTimeout(() => {
          store.dispatch(utlityActionUpdateRequest(requestId, REQUEST_STATUS.FAILED));
        }, 800);
      }

      // If we get a 401, it means session has expired, redirect to login
      if (error && error.response && error.response.status === 401) {
        store.dispatch(clearSession());
        store.dispatch(loginFailure({ message: intl.get('global.errors.invalidToken') }));
        window.location.href = DOMPurify.sanitize(LOGOUT_URL);
        return null;
      } else if (error && error.response && error.response.status === 403) {
        store.dispatch(showNotification('Something wrong occurred.', { variant: 'error' }));
      }

      if (error && !error.response) {
        if (error.error && error.error.code === '403') {
          return store.dispatch({ type: messagingTypes.CHECK_STATUS });
        }
        store.dispatch({ type: 'FATAL_NETWORK_ERROR', message: error });
      } else {
        if (errorAction) {
          store.dispatch({ type: errorAction, data: error.response });
        } else {
          return error.response.data;
        }
      }
    });
}

export default axiosRequest;
